export default __webpack_public_path__ + "static/media/cone_coins.00c071bb.png";